
/**
 * button_call_pressed
 * Тап на кнопку "Позвонить бесплатно"
 */
export interface ButtonCallPressed {}

export function mapButtonCallPressedEvent(event: ButtonCallPressed): object {
  const props: Record<string, unknown> = {
  };

  return {
    event: 'analytics_event',
    event_name: 'button_call_pressed',
    event_properties: {},
  };
}
